<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div class="stopusing-detail-top" v-if="cardInfo">
                   <!-- <span class="cake-center shadow"></span> -->
<!--                     <img :src="cardInfo.imageUrl" />-->
                      <span class="card-image-border-none" :style="{ backgroundImage:'url('+cardInfo.imageUrl+')'}"></span>
                      <div>
                          <em>{{ Number(cardInfo.remainCash).toLocaleString() }}</em>
                          <strong>{{ cardInfo.prepaidCardNickName }}</strong>
                          <span>구매일<small>{{ cardInfo.issueDate }}</small></span>
                      </div>
                </div>
                <div class="line-box" v-if="cardInfo">
                    <div class="gray-line"></div>
                </div>
                
                <div class="popup-textbox">
                  <span v-html="message">
                  </span>
                </div>
            </div>
            <div class="button-wrap">
              <button class="button-bg-gray" @click.prevent="noEvent()">아니요</button>
              <button class="button-bg-yellow" @click.prevent="yesEvent()">예</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'bottomPopup',
  props: ["message", "cardInfo"],
  data() {
    return  {

    }
  },
  methods : {
    noEvent() { //아니오 버튼 눌렀을때 이벤트
      this.$emit('noEvent', false);
    },
    yesEvent() {    //예 버튼 눌렀을때 이벤트
      this.$emit('yesEvent', this.cardInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/emarticonPaymentVoidPopup.scss';
</style>